import { render, staticRenderFns } from "./tipText.vue?vue&type=template&id=b4ed8208"
import script from "./tipText.vue?vue&type=script&lang=js"
export * from "./tipText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports